import React from "react";
import styles from "./style.scss";

const DateAndLocation = props => {
  const {
    ad: { postedTime, location }
  } = props;

  return (
    <div className={styles.wrapper}>
      <span className={styles.value}>{postedTime}</span> |{" "}
      <span className={styles.value}>{location}</span>
    </div>
  );
};

export default DateAndLocation;



// WEBPACK FOOTER //
// ./src/components/SimilarAdCard/AdSummary/DateAndLocation/index.tsx